import { useTranslate } from 'react-translate';
import { FiArrowUpRight } from 'react-icons/fi';

const IosCard = ({ img, title, description, tech, app, index }) => {
  const t = useTranslate('IOS');

  return (
    <article
      className='project-card'
      data-aos='fade-up'
      data-aos-delay={index * 70}
    >
      <div className='project-image-wrap'>
        <img src={img} alt={title} />
      </div>

      <div className='relative z-10 flex flex-1 flex-col p-6'>
        <p className='text-xs uppercase tracking-[0.22em] text-[var(--indigo)]'>
          {t('native')}
        </p>
        <h3 className='mt-2 text-2xl font-extrabold text-[var(--text-main)]'>{title}</h3>
        <p className='section-copy mt-5 text-[0.98rem]'>{description}</p>

        <div className='mt-6 flex flex-wrap gap-2'>
          {tech.map((item) => (
            <span key={`${title}-${item}`} className='tag-chip'>
              {item}
            </span>
          ))}
        </div>

        <div className='mt-auto pt-8'>
          <a
            href={app}
            target='_blank'
            rel='noreferrer'
            className='primary-link w-fit'
          >
            {t('store')}
            <FiArrowUpRight />
          </a>
        </div>
      </div>
    </article>
  );
};

export default IosCard;
